<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { Text } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';

	export let disabled = false;

	const dispatch = createEventDispatcher();

	const onClick = (e: MouseEvent) => {
		e.preventDefault();
		if (!disabled) dispatch('click');
	};
</script>

<Text
	href="#"
	styleType="body-small"
	class={disabled ? 'd-block mt-s text-color-muted' : 'd-block mt-s'}
	on:click={onClick}
>
	{$format('settings_link_reset_to_default', { default: 'Reset to default' })}
</Text>
